import { notStandardAjax } from "./fetch";

// 验证token
export async function verify(token) {
  const { data } = await notStandardAjax.get("/sso/verify", { token });
  return data;
}

// 退出登录
export async function logOut() {
  const { data } = await notStandardAjax.get("/logout", {});
  return data;
}
